
import { useEffect } from 'react';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import Hero from '../../components/sections/Hero';
import BrandStory from '../../components/sections/BrandStory';
import ProductShowcase from '../../components/sections/ProductShowcase';
import Services from '../../components/sections/Services';
import BrandIP from '../../components/sections/BrandIP';
import HonorsSummary from '../../components/sections/HonorsSummary';
import News from '../../components/sections/News';

export default function Home() {
  useEffect(() => {
    // 设置页面标题和meta信息
    document.title = '马帮瑞贡官网 - 传承三百年马帮精神，奉献地道普洱好茶';
    
    // 添加Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "马帮瑞贡",
      "description": "马帮瑞贡，始于1716年，传承三百年马帮精神的普洱茶品牌。中央政府采购供应商，上海合作组织国宾伴手礼，为您奉献地道普洱好茶。",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
      "logo": "https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/07be70b882e3b43e964a05d6564f6112.jfif",
      "foundingDate": "1716",
      "industry": "茶叶制造",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "CN",
        "addressRegion": "云南省",
        "addressLocality": "普洱市"
      },
      "sameAs": [],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "availableLanguage": "Chinese"
      }
    });
    document.head.appendChild(script);

    return () => {
      // 清理
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <HonorsSummary />
        <BrandStory />
        <ProductShowcase />
        <Services />
        <BrandIP />
        <News />
      </main>
      <Footer />
    </div>
  );
}
